<template>
    <div class="footer">
        <div class="footerBox">
            <div class="footerMsg">
                <ul>
                    <li>
                        <div class="telName"><img src="../images/home/company.png" alt=""/>NAME:</div>
                        <div class="telText companyText">{{uniteData.name}}</div>
                    </li>
                    <li>
                        <div class="telName"><img src="../images/home/mobile.png" alt=""/>TEL:</div>
                        <div class="telText">{{uniteData.mobile}}</div>
                    </li>
                </ul>
            </div>
            <div class="footerNav">
                <NavBar :navStatus="false"></NavBar>
                <div class="address">{{uniteData.address}}</div>
            </div>
            <div class="footerLogo">
                <router-link to="/"><img src="../assets/ty_logo_w.png" alt=""><b>{{logoName}}</b></router-link>
            </div>
        </div>
        <div class="filingBox">
            <div class="filingAuto">
                <li></li>
                <li><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">{{uniteData.filing}}</a></li>
                <li></li>
            </div>
        </div>
    </div>
</template>

<script>
    import NavBar from './navBar'
    // import { uniteData, logoName } from '../util/index';
    
    export default {
        name:'FooterBox',
        data() {
            return {
                uniteData: uniteData,
                logoName: logoName,
            }
        },
        mounted(){ },
        components: { NavBar },
    }
</script>

<style lang="scss" scoped>
    @import '@/style/variables.scss';
    .footer{
        @include h-bgColor(var(--color1C));
        .footerBox{
            width: $navWidth;
            height:280px;
            display: flex;
            justify-content: space-evenly;
            margin:0 auto;
            .footerLogo{
                padding: 60px 0 0;
                width:15%;
                border-left:2px solid var(--footer-b-color);
                a{
                    display: flex;
                    width:130px;
                    margin:0 auto;
                    img{
                        width:32px;
                        margin-right:10px;
                    }
                    b{
                        @include h-fontSize($colorC3,18px,32px);
                    }
                }
                p{
                    font-weight:bolder;
                    margin:10px auto 0 21px;
                    text-align: center;
                    @include h-fontSize($color99,14px,26px);
                }
            }
            .footerNav{
                padding: 60px 0 0;
                width:65%;
                background:url('../images/home/address_bg.png') no-repeat right bottom;
                background-size: 250px;
                .address{
                    margin: 50px auto 0;
                    padding:8px 0;
                    text-align: center;
                    user-select: text;
                    -webkit-user-select: text;
                    @include h-fontSize($colorC3,14px,16px);
                }
            }
            .footerMsg{
                padding: 60px 0 0 20px;
                width:20%;
                border-right:2px solid var(--footer-b-color);
                ul{
                    li{
                        user-select: text;
                        -webkit-user-select: text;
                        margin-bottom:20px;
                        @include h-fontSize($colorC3,20px,24px);
                        .telName{
                            font-size:13px;
                            display: flex;
                            align-items: baseline;
                            font-weight: bold;
                            img{
                                width: 18px;
                                height: 18px;
                                margin-right:5px;
                            }
                        }
                        .telText{
                            font-weight: bolder;
                            letter-spacing:1px;
                            user-select: text;
                            -webkit-user-select: text;
                            // padding-left:5px;
                        }
                        .companyText{
                            font-size:15px;
                        }
                    }
                }
            }
        }
        .filingBox{
            user-select: text;
            -webkit-user-select: text;
            border-top:2px solid var(--footer-b-color);
            @include h-fontSize($colorC3,14px,60px);
            .filingAuto{
                width:$navWidth;
                margin:0 auto;
                display: flex;
                justify-content: space-evenly;
                li{
                    &:nth-child(1){
                        width:20%;
                        // border-right:2px solid $color33;
                    }
                    &:nth-child(2){
                        width:65%;
                        text-align: center;
                    }
                    &:nth-child(3){
                        width:15%;
                        // border-left:2px solid $color33;
                    }
                }
                a{
                    color:$colorC3;
                    user-select: text;
                    -webkit-user-select: text;
                }
            }
        }
    }
    
</style>